// One measured timeline is used by both the camera and the copy.
// No hardcoded pixel milestones: svh, content height and resize stay in sync.
export const clamp01 = x => Math.max(0, Math.min(1, x));
export const smooth01 = x => { const t = clamp01(x); return t*t*(3-2*t); };
export const range = (a,b,x) => smooth01((x-a)/(b-a));
const top = node => node.getBoundingClientRect().top + window.scrollY;
export function measureStory() {
  const starts=Array.from({length:7},(_,i)=>{const node=document.getElementById(`chapter-${i}`);return node?top(node):i*innerHeight;});
  const handoff=document.getElementById('story-handoff'),end=document.getElementById('capabilities')||document.getElementById('panels');
  return {starts,handoffStart:handoff?top(handoff):starts[6]+innerHeight,end:end?top(end):starts[6]+innerHeight*2};
}
export function storyState(scroll,layout){
  const {starts,handoffStart,end}=layout;
  let segment=6;
  for(let i=0;i<6;i++)if(scroll<starts[i+1]){segment=i+clamp01((scroll-starts[i])/Math.max(1,starts[i+1]-starts[i]));break;}
  const index=Math.min(5,Math.floor(segment)),mix=clamp01(segment-index),beat=Math.min(6,Math.round(segment));
  const handoff=clamp01((scroll-handoffStart)/Math.max(1,end-handoffStart));
  const scale=1-.13*clamp01(handoff/.5),y=-.7*innerHeight*clamp01((handoff-.5)/.5);
  return {segment,index,mix,beat,handoff,scale,y,visible:scroll<end,progress:segment/6};
}
